var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnsavedChangesDot = function SvgUnsavedChangesDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.2px",
    height: "11px",
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.8
  })));
};
export default SvgUnsavedChangesDot;